import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { ArgoApp } from '@amzn/awsscm-argo-core';

import App from './App';
import * as serviceWorker from './serviceWorker';

import './styles.scss';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

window.React = require('react');
window.ReactDOM = require('react-dom');

root.render(
  <div className="awsui argo">
    <React.StrictMode>
      {
        // A BrowserRouter allows us to render and navigate between different pages
        // See https://reacttraining.com/react-router/web/guides/quick-start for more info
        // Setting the basename prop allows this page to be rendered from that base path.
        // This value should match the path on the homepage attribute in your package.json.
      }
      <BrowserRouter basename={'/inventory-receive'}>
        <ArgoApp content={<App />} />
      </BrowserRouter>
    </React.StrictMode>
  </div>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
